import type { CSSProperties } from 'react';
import { GRAPH_CONFIG } from '../types/graph';

// Legend uses display-friendly labels for edge types
const EDGE_LEGEND: Record<string, string> = {
  'Imports (TS/Python/Swift)': GRAPH_CONFIG.edgeColors['import'],
  'Using (C#)': GRAPH_CONFIG.edgeColors['using'],
  'HTTP Calls': GRAPH_CONFIG.edgeColors['http-call'],
};

const titleStyle: CSSProperties = {
  margin: '0 0 var(--space-md) 0',
  fontSize: 'var(--font-size-base)',
  fontWeight: 600,
  color: 'var(--color-text-primary)',
  letterSpacing: '0.03125rem'
};

const legendItemStyle: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  marginBottom: 'var(--space-sm)',
  gap: 'var(--space-md)'
};

const colorBoxStyle = (color: string): CSSProperties => ({
  width: 'var(--font-size-base)',
  height: 'var(--font-size-base)',
  borderRadius: '0.1875rem',
  backgroundColor: color,
  flexShrink: 0,
  boxShadow: '0 0.125rem 0.375rem rgba(0,0,0,0.3)'
});

const labelStyle: CSSProperties = {
  color: '#ccc',
  fontSize: 'var(--font-size-sm)'
};

const edgeLineStyle = (color: string): CSSProperties => ({
  width: '1.5rem',
  height: '0.125rem',
  backgroundColor: color,
  position: 'relative',
  flexShrink: 0
});

const edgeArrowStyle: CSSProperties = {
  position: 'absolute',
  right: '-0.25rem',
  top: '-0.1875rem',
  width: 0,
  height: 0,
  borderLeft: '0.3125rem solid',
  borderTop: '0.25rem solid transparent',
  borderBottom: '0.25rem solid transparent'
};

const sectionDividerStyle: CSSProperties = {
  margin: 'var(--space-lg) 0',
  borderTop: '1px solid rgba(255, 255, 255, 0.1)'
};

export function Legend() {
  return (
    <div className="hud-panel" style={{ padding: 'var(--space-lg)', fontSize: 'var(--font-size-sm)' }}>
      {/* Service Colors (Nodes) */}
      <div style={titleStyle}>SERVICES</div>
      {Object.entries(GRAPH_CONFIG.serviceColors).map(([service, color]) => (
        <div key={service} style={legendItemStyle}>
          <div style={colorBoxStyle(color)} />
          <span style={labelStyle}>{service}</span>
        </div>
      ))}

      {/* Divider */}
      <div style={sectionDividerStyle} />

      {/* Edge Types (Links) */}
      <div style={titleStyle}>DEPENDENCIES</div>
      {Object.entries(EDGE_LEGEND).map(([edgeType, color]) => (
        <div key={edgeType} style={legendItemStyle}>
          <div style={edgeLineStyle(color)}>
            <div style={{...edgeArrowStyle, borderLeftColor: color}} />
          </div>
          <span style={labelStyle}>{edgeType}</span>
        </div>
      ))}
    </div>
  );
}
